import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.js';

export const HelpMeChooseResultSkeleton: React.FC = () => {
  return (
    <div className="mb-comfy-xl">
      <div className="mb-comfy-lg">
        <div className="heading-sm heading-neutral-amplified">
          <Skeleton height="1.5rem" width="25%" />
        </div>
        <div className="label-moderate label-lg mt-snug-lg">
          <Skeleton height="1rem" width="80%" />
        </div>
      </div>
      <div>
        <div className="ChildBio ChildBio__flex flex flex-col">
          <div className="ChildBio__content flex flex-col sm:flex-row gap-comfy-sm sm:gap-comfy-xl">
            <div className="ChildBio__media flex-1 align-start">
              <div className="sm:hidden">
                <div>
                  <Skeleton height="1.5rem" width="55%" />
                </div>
              </div>
              <div className="pb-roomy-sm">
                <Skeleton
                  width="100%"
                  height="auto"
                  style={{
                    aspectRatio: '3/4',
                  }}
                  borderRadius="0.5rem"
                />
              </div>
            </div>
            <div className="ChildBio__summary flex flex-col flex-1 gap-comfy-sm sm:gap-0 sm:pt-0">
              <div className="hidden sm:block mb-comfy-lg">
                <Skeleton height="4rem" width="55%" />
              </div>
              <div className="mb-0 sm:pb-comfy-sm text-sm order-1 ">
                <Skeleton height="1rem" width="88%" />
                <Skeleton height="1rem" width="92%" />
                <Skeleton height="1rem" width="95%" />
                <Skeleton height="1rem" width="90%" />
                <Skeleton height="1rem" width="85%" />
                <Skeleton height="1rem" width="30%" />
              </div>
              <div className="order-2 sm:order-last">
                <Skeleton height="2em" width="40%" />
              </div>
              <div className="order-3">
                <p>
                  <Skeleton height="1.5rem" width="60%" />
                </p>
                <p>
                  <Skeleton height="1.5rem" width="60%" />
                </p>
                <p>
                  <Skeleton height="1.5rem" width="60%" />
                </p>
                <p>
                  <Skeleton height="1.5rem" width="60%" />
                </p>
                <p>
                  <Skeleton height="1.5rem" width="60%" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
